module.exports = __webpack_public_path__ + "img/qyp4.5dce99f2.jpg";